import { computed } from 'vue-demi';

export default (props) => {
    const paginationCssVar = computed(() => {
        return {
            '--swiper-pagination-color': props.tpl.props.activeColor,
            '--swiper-pagination-bullet-inactive-color': props.tpl.props.inactiveColor
        };
    });

    return {
        paginationCssVar
    };
};
